/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation041.less';

interface IAnimation041Item {
  text: string;
  title: string;
}

interface IAnimation041Props {
  items: IAnimation041Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation041: React.FunctionComponent<IAnimation041Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };
  return (
    <div className={`animation041 component ${className || ''}`}>
      {items.map((itm: IAnimation041Item, idx: number) => (
        <div
          key={idx}
          className={`animation041-item r${idx + 1} animation ${
            play >= idx + 1 ? 'fade-in' : ''
          }`}
          onClick={() => startPlay()}
        >
          <img
            className={`click-point ${play > 1 ? 'hide' : ''}`}
            src={ImgPoint}
            alt=""
          />
          <div
            className="animation041-title"
            dangerouslySetInnerHTML={{ __html: itm.title }}
          />
          <div
            className="animation041-text"
            dangerouslySetInnerHTML={{ __html: itm.text }}
          />
        </div>
      ))}
    </div>
  );
};

export default Animation041;
